module.exports = __webpack_public_path__ + "img/jawg-streets.76a9a60c.jpg";